import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.config.productionTip = false;

// Axios
import axios, { AxiosStatic } from 'axios';
Vue.prototype.$http = axios;

declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosStatic;
  }
}
// ------------

// VeeValidate
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from 'vee-validate';

import { required, email, regex, min, max } from 'vee-validate/dist/rules';

// No message specified.
extend('email', email);
extend('required', required);
extend('regex', regex);
extend('min', min);
extend('max', max);

import en from 'vee-validate/dist/locale/en.json';
localize({ en });

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
// ------------

// Bootstrap
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
// ------------

// Analytics
// import VueGtag from "vue-gtag";

// Vue.use(VueGtag, {
//   config: { id: "G-77PE1S4HWX" },
//   params: {
//     'allow_google_signals': false,
//     'allow_ad_personalization_signals': false,
//     'anonymize_ip': true
//   },
//   enabled: process.env.NODE_ENV === 'production'
// });

import('@/assets/base-hackyholidays-2021.scss');

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
